import React, { useState } from "react";
import { ReactComponent as RadioIcon } from "../assets/icons/main/Ellipse 1.svg";
import { ReactComponent as CheckedRadioIcon } from "../assets/icons/main/Ellipse 2.svg";
import { Radio } from "@mui/material";
import { get } from "lodash";
import { useOutletContext } from "react-router-dom";
import { palette } from "../theme/palette";
import lightOrdarkColor from "@check-light-or-dark/color";

const Styles = {
  checkedIcon: {
    fontSize: "0.8rem",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
};

export default function RadioComponent(props: any) {
  const [checked, setChecked] = useState(false);
  const themeData: any = get(useOutletContext(), 'themeData', {});

  const handleCheckboxChange = (event: any) => {
    setChecked(event.target.checked);
  };

  return (
    <div>
      <Radio
        {...props}
        icon={
          <>
            {!props.disabled ? (
              <RadioIcon style={{ fontSize: "1.2rem", color: themeData.palette.primary.main }} />
            ) : (
              <RadioIcon style={{ fontSize: "1.2rem" , color:  lightOrdarkColor(themeData.palette.background.default) === 'dark' ?  palette.disabledColor.dark : palette.disabledColor.dark}} />
            )}
          </>
        }
        checkedIcon={
          <div style={{ display: "flex", alignItems: "center" }}>
            {!props.disabled ? (
              <>
                <RadioIcon style={{ fontSize: "1.2rem" }} />
                <CheckedRadioIcon
                  style={{...Styles.checkedIcon, position:'absolute', color: themeData.palette.primary.main  }}
                />
              </>
            ) : (
              <>
                <RadioIcon style={{ fontSize: "1.2rem", color: palette.disabledColor.dark }} />
                <CheckedRadioIcon
                 style={{...Styles.checkedIcon, position:'absolute', color:  lightOrdarkColor(themeData.palette.background.default) === 'dark' ?  palette.disabledColor.dark : palette.disabledColor.light}}
                />
              </>
            )}
          </div>
        }
      />
    </div>
  );
}
